import { module } from 'modujs';
import barba from '@barba/core';
import { html } from '../utils/environment';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const transitionDuration = 500;
        function delay(n) {
            return new Promise((done) => {
                setTimeout(() => {
                    done();
                }, n);
            });
        }
        barba.init({
            timeout: 8000, // default is 2000ms
            transitions: [{
                name: 'default-transition',
                leave: async (data) => {
                    const done = async () => { };
                    this.call('destroy', data.current.container, 'app');
                    await delay(transitionDuration);
                    done();
                },
                enter: async (data) => {
                    this.call('update', data.next.container, 'app');
                }
            }],
            views: [{
                namespace: 'single-happy-merchants',
                beforeEnter: () => {
                    html.classList.add('-single-happy-merchants');
                },
                afterLeave: () => {
                    html.classList.remove('-single-happy-merchants');
                }
            },
            {
                namespace: 'solutions',
                beforeEnter: () => {
                    html.classList.add('has-dark-background');
                }
            }]
        });

        barba.hooks.afterLeave(() => {
            html.classList.remove('has-dark-background');
        });

        barba.hooks.beforeLeave(() => {
            html.classList.add('is-leaving-page');
            gsap.set(html, {
                overflow: 'hidden',
            });
            gsap.to(document.querySelector('#barba-wrapper'), {
                opacity: 0,
                duration: transitionDuration / 1000,
                ease: 'power2.out'
            });
        })

        barba.hooks.enter(() => {
            html.classList.remove('is-leaving-page');
            html.classList.add('is-entering-page');
            html.removeAttribute('style');
            window.dispatchEvent(new Event('resize'));
            gsap.to(document.querySelector('#barba-wrapper'), {
                opacity: 1,
                duration: transitionDuration / 1000,
                delay: transitionDuration / 2000,
                ease: 'power2.in'
            });
            setTimeout(() => {
                html.classList.remove('is-entering-page');
                html.classList.add('new-page-loaded');
                window.dispatchEvent(new Event('resize'));
            }, transitionDuration);
        });
    }
}
